import React from 'react';

import ConsumableShow from '@components/shared/consumables/ConsumableShow';
import { useLoaderData } from 'react-router-dom';

export default function AdminConsumableShow() {
  const consumable = useLoaderData();

  return (
    <ConsumableShow
      consumable={consumable}
      role="admin"
    />
  );
}
